import Type from './../types'

export default {
    state: {
        example: '这是例子',
        curModelInfo: {},
        modelsInfo: [],
        webModels: '',
        webid: 1,
        hidefooter: true,
        active_chanel_index: 0,
        logosrc: "",
        loginsuccess: false,

        sort:"1",//排序方式，1位入库时间        2为拍摄时间
        struct:"1",  //构图方式
        startTime:"",//开始时间
        endTime:"",  //结束时间
        isGaonS:'',
        isEnglish:"",
        area:'',
        countrydata:[], //国家数据
        citydata:[] //城市数据
    },
    mutations: {

        [Type['SORT']](state, data) {
            state.sort = data
        },
        [Type['STRUCT']](state, data) {
            state.struct = data
        },
        [Type['STARTTIME']](state, data) {
            state.startTime = data
        },
        [Type['ENDTIME']](state, data) {
            state.endTime = data
        },
        [Type['EXAMPLE']](state, data) {
            state.example = data
        },
        [Type['CURRENT_MODEL_INFO']](state, data) {
            state.curModelInfo = data
        },
        [Type['MODELS_INFO']](state, data) {
            state.modelsInfo = data
        },
        [Type['WEB_MODELS']](state, data) {
            state.webModels = data
        },
        [Type['WEB_ID']](state, data) {
            state.webid = data
        },
        [Type['HIDE_FOOTER']](state, data) {
            state.hidefooter = data
        },
        [Type['ACTIVE_CHANEL_INDEX']](state, data) {
            state.active_chanel_index = data;
        },
        [Type['LOGO_SRC']](state, data) {
            state.logosrc = data;
        },
        [Type['LOGIN_SUCCESS']](state, data) {
            state.loginsuccess = data;
        },
        [Type['IS_GAONS']](state, data) {
            state.isGaonS = data
        },
        [Type['IS_ENGLISH']](state, data) {
            state.isEnglish = data
        },
        [Type['setArea_mutations']](state,data){
            state.area= data;
        },
        [Type['setCountry_mutations']](state,data){
            state.countrydata = data;
        },
        [Type['setCity_mutations']](state,data){
            state.citydata= data;
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js